<script setup>
import { ref, watch } from 'vue'
import { eventService } from '@/http'
import { useRoute, useRouter } from 'vue-router'

import ThumbCover from '@/Components/ThumbCover.vue'
import Report from '@/Modals/Report.vue'

import { timeAgo } from '@/Utils/date'

const route = useRoute()
const router = useRouter()


const item = ref({
    id: ''
})



const fetchData = () => {
    eventService.get({id: route.params.id}).then(res => {
        item.value = res.data
    })
}

const join = () => {
    eventService.join({id: route.params.id}).then(res => {
        console.log(res)
        fetchData()
    })
}

watch(
  () => route.params,
  async () => {
    fetchData()
  },
  {
    flush: 'post',
    immediate: true
  }
)

</script>
<template>
<div class="blog-page">
    <article class="blog">
        <template v-if="item.title">
            <ThumbCover class="blog__img" :item="item" />
            <div class="blog__header">
                <h1 class="blog__title">{{ item.title }}</h1>
                <Modal className="blog__report" title="Жалоба" :auth="true">
                    <Icon name="flag" />
                    <template #content>
                        <Report type="blog" :id="item.id" />
                    </template>
                </Modal>
            </div>
            <div class="blog__address"><Icon name="map-pin" />{{ item.address }}</div>
            <div class="blog__text" v-html="item.text"></div>
            
            <template v-if="!store.isAuth">
                <Modal  className="blog__join" :auth="true" :callback="() => join()">
                    Присоединиться
                </Modal>
            </template>
            <template v-else> 
                <button v-if="item.joined" class="blog__join" @click.prevent="join">
                    Выйти
                </button>
                <button v-else class="blog__join" @click.prevent="join">
                    Присоединиться
                </button>
            </template>
            
            <h3 class="blog__sub">Собираются посетить:</h3>
            <div class="blog__joined">
                <div class="join" v-for="user in item.users" :key="user.id">
                    <Link tag="div" class="join__photo" :to="{ name: 'user', params: { user: user.id } }">
                        <img v-if="user.photo" :src="user.photo" alt="" />
                        <Icon v-else name="face-smile" />
                    </Link>
                    
                    <Link tag="div" class="join__info" :to="{ name: 'user', params: { user: user.id } }">
                        <span class="join__name">{{ user.name }}</span>
                    </Link>
                </div>
            </div>
        </template>
    </article>

</div>
</template>

